import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTabsComponent from './adpTabs.component';

let adpTabsModule = angular.module('adpTabs', [
  uiRouter
])

.component('adpTabs', adpTabsComponent)

.name;

export default adpTabsModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTabs/adpTabs.js